import React from 'react'
import DonationFeed from '@common/components/DonationFeed'

const Donations = ({ application, child, donations }) => {
  const manualDonations = [
    child.bonus_amount_in_cents > 0 && {
      isBonus: true,
      image: application.logo_avatar_url,
      name: 'School-Fun-Run',
      message: application.bonus_amount_message,
      amount: child.bonus_amount_in_cents / 100
    },
    child.adjustment_amount_in_cents > 0 && {
      image: application.logo_avatar_url,
      name: 'Admin',
      message: 'Online amount adjustment',
      amount: child.adjustment_amount_in_cents / 100
    }
  ].filter(Boolean)

  return (
    <DonationFeed
      manualDonations={manualDonations}
      child={child}
      data={donations}
      status='fetched'
    />
  )
}

export default Donations
